<template>
  <div id="app">
    <Header />
    <router-view />
    <Menu v-if="showMenu" @playAudio="playAudio" />
    <AudioPlayer :queue="audioQueue" ref="audioplayer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "./views/Header";
import Menu from "@/components/Menu";
import AudioPlayer from "@/components/AudioPlayer";

export default {
  components: {
    Header,
    Menu,
    AudioPlayer
  },
  computed: {
    ...mapState(["showMenu", "audioQueue", "audio"])
  },
  beforeCreate() {
    const lng = localStorage.getItem("lng");
    if (lng && lng != null) {
      this.$i18n.locale = lng;
      this.$store.dispatch("changeLocale", lng);
    }
  },
  created() {
    this.getAudioQueue();
  },
  methods: {
    ...mapActions(["getAudioQueue"]),
    playAudio(playing) {
      const audioplayer = this.$refs.audioplayer;
      const audio = this.audio;
      !playing
        ? audioplayer.pause()
        : audio.inQueue
          ? audioplayer.play()
          : audioplayer.playQueue();
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "Songti SC", STZhongsong, STSong, SimSun, 宋体;
  font-weight: 500;
}

@media screen and (max-width: 320px) {
  html,
  body {
    font-size: 14px;
  }
}

body {
  background-image: url("./assets/img/bg.jpg");
  background-position: bottom center;
  background-size: auto 100%;
}

div,
header,
footer,
nav,
ul,
ol,
li {
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

ol {
  padding: 0;
}

ul {
  padding: 0;
  list-style: none;
}

dl,
dt,
dd {
  margin: 0;
}

input {
  background: none;
  border: 0;
  outline: none;
}

input[type="button"],
input[type="submit"],
input[type="reset"] {
  -webkit-appearance: none;
}

textarea {
  -webkit-appearance: none;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.page {
  position: relative;
  z-index: 1;
  top: 0;
  width: 100%;
  height: 100vh;
  min-height: 500px;
  padding-top: 3.25rem;
  overflow: hidden;
  zoom: 1;
  background-repeat: no-repeat;
  background-origin: content-box;
  background-size: cover;
}
</style>
